import { print } from 'graphql';

import findManyPostQuery from '~/shared/graphql-queries/posts/find-many-post-query';
import removeByIdPostMutation from '~/shared/graphql-queries/posts/remove-by-id-post-mutation';
import updateByIdPostMutation from '~/shared/graphql-queries/posts/update-by-id-post-mutation';
import type { BuilderType } from '~/types';

type RemoveByIdPostArgs = Readonly<{
  _id?: string;
}>;

type PostItem = Readonly<{
  _id?: string;
  alias?: string;
  title?: string;
  image?: Readonly<{
    path?: string | null;
  }> | null;
}>;

type FindManyPostArgs = Readonly<{
  limit?: number;
  filter?: Record<string, unknown>;
  sort?: string;
}>;

type FindManyPostResponse = Readonly<{
  findManyPostQuery: PostItem[];
}>;

type UpdateByIdPostArgs = Readonly<{
  _id?: string;
  record?: Record<string, unknown>;
}>;

export const postsTagTypes = ['Posts'] as const;

export const getPostsQuery = (builder: BuilderType) => {
  return {
    removeByIdPost: builder.mutation<unknown, RemoveByIdPostArgs>({
      query: (args) => ({
        url: '',
        method: 'POST',
        body: JSON.stringify({
          query: print(removeByIdPostMutation),
          variables: {
            _id: args?._id,
          },
        }),
      }),
      invalidatesTags: ['Posts'],
    }),

    findManyPostQuery: builder.query<FindManyPostResponse, FindManyPostArgs>({
      query: (args) => ({
        url: '',
        method: 'POST',
        body: JSON.stringify({
          query: print(findManyPostQuery),
          variables: {
            limit: args?.limit,
            sort: args?.sort,
            filter: args?.filter,
          },
        }),
      }),
      providesTags: ['Posts'],
      keepUnusedDataFor: 300,
    }),

    updateByIdPost: builder.mutation<unknown, UpdateByIdPostArgs>({
      query: (args) => ({
        url: '',
        method: 'POST',
        body: JSON.stringify({
          query: print(updateByIdPostMutation),
          variables: {
            _id: args?._id,
            record: args?.record,
          },
        }),
      }),
      invalidatesTags: ['Posts'],
    }),
  };
};
